import React from "react";
import ListItem from "../../ui_atoms/ListItem";
import { RootStackParamList } from "../../navigations/RootNavigation";
import { StackScreenProps } from "@react-navigation/stack";

type MissionClientFeesProps = StackScreenProps<
    RootStackParamList,
    "MissionInfoDeductions"
>["route"]["params"];

const MissionInfoDeductions = ({ deductions }: MissionClientFeesProps) => {
    return deductions.map((display) => <ListItem {...display} key={display.key} />);
};

export default MissionInfoDeductions;
